export class DashboardAlarmHtml {
    alarmskin() {
        return `
            <div class="container-layout full-height">
                <div class="container-column">
                    <div class="column-switch-toggle-tab">
                        <div class="tab-switch">
                            <span class="tabLabel">Realtime</span>
                            <label class="switch">
                                <input type="checkbox" id="tabToggle" />
                                <span class="slider"></span>
                            </label>
                            <span class="tabLabel">Historical</span>
                        </div>
                    </div>
                    <div class="container-body">
                        <div class="container-toolbar">
                            <div class="info-bar has-icon">
                                <span class="iconify" data-icon="mdi:calendar-clock-outline"></span>
                                <div class="bar-row">
                                    <p id="alarm-tip">0 alarm events</p>
                                    <p id="time-lapse">Last 8 hours</p>
                                </div>
                            </div>
                            <div class="toolbar-menu">
                                <div class="search-input">
                                    <input type="text" id="searchInput" placeholder="search..." />
                                    <button type="button" class="search-toggle">
                                        <span class="iconify" data-icon="uil:search"></span>
                                    </button>
                                </div>
                                <div class="dropdown" data-dropdown-id="filter-dropdown">
                                    <button class="dropdown-toggle" aria-haspopup="true" aria-expanded="false">
                                        <span class="iconify" data-icon="bx:filter"></span>
                                    </button>
                                    <div class="dropdown-menu" role="menu">
                                        <button role="menuitem">Name</button>
                                        <button role="menuitem">Date</button>
                                    </div>
                                </div>
                                <div class="dropdown" data-dropdown-id="user-settings">
                                    <button class="dropdown-toggle" aria-haspopup="true" aria-expanded="false">
                                        <span class="iconify" data-icon="solar:settings-bold"></span>    
                                    </button>
                                    <div class="dropdown-menu" role="menu">
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="custom-filter"></div>
                        <div class="table-responsive">
                            <table class="has-min-width data-table">
                            <thead>
                                
                            </thead>
                            <tbody>
                            
                            </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        `;
    }
}